import Link from 'next/link'
import { forwardRef, useRef } from 'react'
import mergeRefs from 'react-merge-refs'
import cn from 'classnames'

import type { TextElementType, CommonTypographyProps } from './typing'
import styles from './index.module.css'

export const Typography = forwardRef<TextElementType, CommonTypographyProps>(
  ({ view = 'medium_14', color, href, tag: Component = 'p', className, children, ...restProps }, ref) => {
    const textRef = useRef<HTMLElement>(null)

    if (href) {
      return (
        <Link style={{ color }} className={cn(styles.component, styles[view], className)} href={href} {...restProps}>
          {children}
        </Link>
      )
    }

    return (
      <Component
        style={{ color }}
        className={cn(styles.component, styles[view], className)}
        ref={mergeRefs([textRef, ref])}
        {...restProps}
      >
        {children}
      </Component>
    )
  },
)

Typography.displayName = 'Typography'
